import { useDispatch } from 'react-redux';
import {
  useGetConversationSource,
  useHasConversationBeenInitiated,
  useIsConversationEnded,
} from '@rsos/reduxDataStore/src/features/conversations/utils';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { setSelectedTab } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { CHAT_TAB } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import { ChatContextProvider } from '../../CallChats/ChatContext';
import ConversationsChatHeader from '../../CallChats/ConversationsChatBox/ConversationsChatHeader';
import LiveChatCard from './LiveChatCard';

const ConversationsChatCard = () => {
  const dispatch = useDispatch();

  const selectedCallerID = useSelectedCallerID() || '';
  const hasConversationBeenInitiated =
    useHasConversationBeenInitiated(selectedCallerID);
  const isConversationEnded = useIsConversationEnded(selectedCallerID);
  const showLiveChat = hasConversationBeenInitiated && !isConversationEnded;
  const conversationSource = useGetConversationSource(selectedCallerID);

  const handleStartChat = () => {
    // Ensure the chat is expanded when navigating to Chat tab
    dispatch(setSelectedTab(CHAT_TAB));
  };

  return (
    <>
      {showLiveChat ? (
        <LiveChatCard
          onClick={handleStartChat}
          callerID={selectedCallerID}
          source={conversationSource}
          isConversationEnded={isConversationEnded}
        />
      ) : (
        <ChatContextProvider chatType="conversations">
          <ConversationsChatHeader
            isConversationStarted={hasConversationBeenInitiated}
            handleStartChat={handleStartChat}
            isForOverview
          />
        </ChatContextProvider>
      )}
    </>
  );
};

export default ConversationsChatCard;
